import 'firebase/auth'

import { memoize } from 'lodash'
import * as firebase from 'firebase/app'

export const initFirebase = memoize((config: string) => {
  firebase.initializeApp(JSON.parse(config))
})
